export const FEED_POST_FORM_ACTION = {
  SHOW_LOADER: 'SHOW_LOADER',
  HIDE_LOADER: 'HIDE_LOADER',

  ATTACH_PREVIEW_SHOW: 'ATTACH_PREVIEW_SHOW',
  ATTACH_PREVIEW_HIDE: 'ATTACH_PREVIEW_HIDE',

  PARSE_REQUEST: 'PARSE_REQUEST',
  PARSE_SUCCESS: 'PARSE_SUCCESS',
  PARSE_FAIL: 'PARSE_FAIL',

  ATTACH_IMAGE: 'ATTACH_IMAGE',
  ATTACH_IMAGE_FAIL: 'ATTACHED_FAIL',
  REMOVE_ATTACHED_IMAGE: 'REMOVE_ATTACHED_IMAGE',

  CHANGE_TEXT: 'CHANGE_TEXT',

  REMOVE_PARSED_DATA: 'REMOVE_PARSED_DATA',
  CHANGE_SELECTBOX: 'CHANGE_SELECTBOX',
  CHANGE_PARSED_DATA: 'CHANGE_PARSED_DATA',

  SET_SATE: 'SET_SATE',
};

export const FeedPostFormReducer = (state, action) => {
  const { type, data } = action;
  switch (type) {
    case FEED_POST_FORM_ACTION.PARSE_REQUEST:
      return {
        ...state,
        isLoading: true,
        isParseModeOn: false,
        showShareLinkPreview: false,
        parsedData: null,
      };

    case FEED_POST_FORM_ACTION.PARSE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isParseModeOn: true,
        showShareLinkPreview: true,
        parsedData: {
          ...data,
          titleEdited: '',
          contentEdited: '',
        },
      };

    case FEED_POST_FORM_ACTION.PARSE_FAIL:
      return { ...state, isLoading: false, isParseModeOn: true };

    case FEED_POST_FORM_ACTION.REMOVE_PARSED_DATA:
      return {
        ...state,
        isParseModeOn: true,
        parsedData: null,
        showShareLinkPreview: false,
      };

    case FEED_POST_FORM_ACTION.ATTACH_IMAGE:
      return { ...state, isParseModeOn: false, ...data };

    case FEED_POST_FORM_ACTION.REMOVE_ATTACHED_IMAGE:
      return {
        ...state,
        isParseModeOn: true,
        attach: null,
        attachPreview: null,
        attachError: null,
      };

    case FEED_POST_FORM_ACTION.ATTACH_IMAGE_FAIL:
      return { ...state, attachError: data, isParseModeOn: true };

    case FEED_POST_FORM_ACTION.CHANGE_TEXT:
      return { ...state, text: data };

    case FEED_POST_FORM_ACTION.CHANGE_SELECTBOX:
      return { ...state, share: data };

    case FEED_POST_FORM_ACTION.CHANGE_PARSED_DATA:
      return { ...state, parsedData: { ...state.parsedData, ...data } };

    case FEED_POST_FORM_ACTION.SHOW_LOADER:
      return { ...state, isLoading: true };

    case FEED_POST_FORM_ACTION.HIDE_LOADER:
      return { ...state, isLoading: false };

    case FEED_POST_FORM_ACTION.SET_SATE:
      return { ...data };

    default:
      throw new Error();
  }
};
